<template>
  <div class="footer">
    <b-container>
      <b-row>
        <b-col cols="12" sm="6">Copyright © Subastas FTS {{ year }}</b-col>
        <b-col cols="12" sm="6">
          <ul class="menu d-none">
            <li>
              <a href="#">Vehículos en subasta</a>
            </li>
            <li>
              <a href="#">Ingreso</a>
            </li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    year: function () {
      return new Date().getFullYear();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/partial";

.footer {
  background-color: $black;
  color: $white;
  padding: 5px 0;
  line-height: 2rem;

  @media (min-width: viewport-min-size("sm")) and (max-width: prev-viewport-max-size("md")) {
    font-size: 0.8rem;
    line-height: 0.8rem;
  }

  @media (max-width: prev-viewport-max-size("xs")) {
    font-size: 0.7rem;
  }

  > div[class^="col-"],
  div[class*=" col-"] {
    display: flex;
    justify-content: center;
    text-align: center;
  }
}

ul.menu {
  list-style: none;
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  padding: 0;

  @media (min-width: viewport-min-size("sm")) and (max-width: prev-viewport-max-size("md")) {
    margin-top: 0;
    margin-bottom: 0;
  }

  li {
    list-style: none;
    flex: 0 0 auto;
    padding: 0 10px;
    border-right: 1px solid $white;
    line-height: 1rem;

    @media (min-width: viewport-min-size("sm")) and (max-width: prev-viewport-max-size("md")) {
      line-height: 0.8rem;
      padding: 0 5px;
    }

    &:last-child {
      padding-right: 0;
      border-right: 0;
    }

    a {
      color: $white;
    }
  }
}
</style>
